/* Three Spirit product recommendations — fetch & mount. Added by Oleg @ IAKOE.
   Kit pattern (see ia-cart-upsell.js + ia-recommendations.liquid):
   - The `ts-recommendations` section server-renders the recommendation cards.
   - Here we fetch it via the Product Recommendations API, take the rendered
     `.ts-pslider__slide` items, drop them into the slider template, and mount it
     so <ia-slider> connects with slides already present and initialises itself. */

if (!customElements.get('ts-product-slider')) {
  customElements.define(
    'ts-product-slider',
    class TsProductSlider extends HTMLElement {
      connectedCallback() {
        if (this._loaded) return;
        this._loaded = true;

        const url = this.dataset.url;
        const pid = this.dataset.pid;
        const tpl = this.querySelector('template.ts-pslider__tpl');
        if (!url || !pid || !tpl) return; // no product context / template

        // The section starts this request inline at parse time (see the
        // ts-product-slider section); fall back to our own fetch if that is missing.
        const pending = window.tsRecsFetch && window.tsRecsFetch[url];
        (pending || fetch(url).then((r) => r.text()))
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const slides = Array.from(doc.querySelectorAll('.ts-pslider__slide'));
            if (!slides.length) {
              this.hideEmpty();
              return;
            }

            const frag = tpl.content.cloneNode(true);
            // Drop the inert <script> the ia-slider snippet emits (already loaded)
            frag.querySelectorAll('script').forEach((s) => s.remove());
            const container = frag.querySelector('.ia-slider__slides');
            if (!container) return;
            slides.forEach((s) => container.appendChild(s));

            // Replace the <template> with the filled slider; <ia-slider> connects
            // with slides present and initialises itself.
            this.replaceChildren(frag);
          })
          .catch(() => this.hideEmpty());
      }

      // No recommendations: the whole section goes (heading and spacing included) on the
      // storefront; the editor keeps it so the merchant can still select it.
      hideEmpty() {
        this.querySelector('.ts-psk')?.remove();
        if (window.Shopify?.designMode) return;
        const section = this.closest('.shopify-section');
        if (section) section.hidden = true;
      }
    }
  );
}
